enum ComponentSize {
  Small = "Small",
}

export default ComponentSize;
